import { render, staticRenderFns } from "./ProductMappings.vue?vue&type=template&id=6db58cfa&scoped=true"
import script from "./ProductMappings.vue?vue&type=script&lang=ts"
export * from "./ProductMappings.vue?vue&type=script&lang=ts"
import style0 from "./ProductMappings.vue?vue&type=style&index=0&id=6db58cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db58cfa",
  null
  
)

export default component.exports